import taxi from 'assets/images/svg/new-plan/benefits/taxi.svg';
import beer from 'assets/images/svg/new-plan/benefits/beer.svg';
import laws from 'assets/images/svg/new-plan/benefits/laws.svg';
import flag from 'assets/images/svg/new-plan/benefits/flag.svg';

export const INFORMATION = [
    {
        id: 1,
        title: 'Si el vehículo asegurado tiene  uso distinto del particular y que no haya sido declarado.',
        img: taxi

    },
    {
        id: 2,
        title: 'Si el conductor del vehículo asegurado se encuentra en estado de ebriedad o drogadicción. ',
        img: beer
    }
    ,
    {
        id: 3,
        title: 'Si el conductor del vehículo asegurado infringe el Reglamento Nacional de Tránsito vigente.',
        img: laws
    }
    ,
    {
        id: 4,
        title: 'Participar en carreras de autos, o incumplir el reglamento de tránsito.',
        img: flag
    }
]


export const TAXI_INFORMATION = [
    {
        id: 1,
        title: 'Si el vehículo asegurado tiene  uso distinto al declarado.',
        img: taxi

    },
    {
        id: 2,
        title: 'Si el conductor del vehículo asegurado se encuentra en estado de ebriedad o drogadicción.',
        img: beer
    }
    ,
    {
        id: 3,
        title: 'Si el conductor del vehículo asegurado infringe el Reglamento Nacional de Tránsito vigente.',
        img: laws
    }
    ,
    {
        id: 4,
        title: 'Participar en carreras de autos, o incumplir el reglamento de tránsito.',
        img: flag
    }
]